// extracted by mini-css-extract-plugin
module.exports = {"root":"footerlp-module--root--8Fa_N","wrapper":"footerlp-module--wrapper--32i-5","line":"footerlp-module--line--1ov1g","item":"footerlp-module--item--2EbNC"};